import { createUnauthenticatedClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { InstallerCompany } from './companies';

export type InstallerSignup = Omit<InstallerCompany, 'id' | 'status' | 'rejectedReason' | 'createdAt' | 'updatedAt'>;

const client = createUnauthenticatedClient('/rest/installer/company/signup');

export const signupInstaller: SaveOperation<InstallerSignup, never> = postRequestFactory<InstallerSignup, never>(
  client,
  { pattern: '' }
);
